/*jshint esversion: 6 */
import React from 'react';
import { connect } from 'react-redux';
import { AppActions, UtilityActions } from 'app/redux/actions.js';
import Analytics from 'app/utility/Analytics.js';

function mapStateToProps(state) {
    return({
        app: state.app
    });
}

function mapDispatchToProps(dispatch) {
    return {
        filterStore: (store, key, value, exact) => {
            dispatch(UtilityActions.filterStore(store, key, value, exact));
        },
        sortStore: (store, key, direction) => {
            dispatch(UtilityActions.sortStore(store, key, direction));
        },
        setApiError: (error) => {
            dispatch(AppActions.apiError(error));
        },
        deleteApiError: (keys) => {
            dispatch(AppActions.deleteApiError(keys));
        },
        setAppError: (error) => {
            dispatch(AppActions.setAppError(error));
        },
        deleteAppError: (keys) => {
            dispatch(AppActions.deleteAppError(keys));
        },
        loginUser: (user) => {
            dispatch(AppActions.loginUser(user));
        },
        createUser: (user) => {
            dispatch(AppActions.createUser(user));
        },
        autologin: (user) => {
            dispatch(AppActions.autologin(user));
        },
        checkUserState: (user) => {
            dispatch(AppActions.checkUserState(user));
        },
        addMessage: (message) => {
            dispatch(AppActions.addMessage(message));
        },
        deleteMessage: (types) => {
            dispatch(AppActions.deleteMessage(types));
        },
        deleteMessageById: (id) => {
            dispatch(AppActions.deleteMessageById(id));
        }
    };
}

function searchState(state, keys, field) {
    let matchedState = [];

    if (keys && keys.length === undefined) {
        keys = [keys];
    } else if (keys === null || keys === undefined) {
        keys = [];
    }

    for (let i = 0; i < state.length; ++i) {
        if (field) {
            if (state[i].error.hasOwnProperty(field)) {
                if (state[i].error) {
                    matchedState.push(state[i].error);
                } else {
                    matchedState.push(state[i]);
                }

            }
        } else {
            for (let j = 0; j < keys.length; ++j) {
                if (state[i].type.match(keys[j])) {
                    if (state[i].error) {
                        matchedState.push(state[i].error);
                    } else {
                        matchedState.push(state[i]);
                    }
                }
            }
        }
    }

    return matchedState;
}

export default function AppProvider(Component) {

    class AppProvider extends React.Component {
        constructor(props) {
            super(props);

            this.getApiErrors = this.getApiErrors.bind(this);
            this.getAppErrors = this.getAppErrors.bind(this);
            this.getPermErrors = this.getPermErrors.bind(this);
            this.getAppMessages = this.getAppMessages.bind(this);
            this.recordEvent = this.recordEvent.bind(this);

            this.analytics = new Analytics(props.app.config.apiUrl);

        }

        getAppErrors(keys) {
            return searchState(this.props.app.errors.local, keys, null);
        }

        getApiErrors(keys) {
            return searchState(this.props.app.errors.api, keys, null);
        }

        getPermErrors(errors) {
            return searchState(this.props.app.errors.api, null, 'perms');
        }

        getAppMessages(keys) {
            return searchState(this.props.app.messages, keys, null);
        }

        recordEvent(data) {
            this.analytics.recordEvent(data);
        }

        render() {
            return (
                <Component
                    getApiErrors={this.getApiErrors}
                    getAppErrors={this.getAppErrors}
                    getPermErrors={this.getPermErrors}
                    getAppMessages={this.getAppMessages}
                    recordEvent={this.recordEvent}
                    {...this.props}/>
            );
        }
    }

    AppProvider.displayName = "AppProvider";

    return connect(mapStateToProps, mapDispatchToProps)(AppProvider);
};
